<template>
  <div class="q-px-2x-md q-pt-xl">
    <div class="row q-col-gutter-x-xl q-col-gutter-y-sm q-mt-xl">
      <div class="col-12">
        <div class="flex justify-between">
          <span class="text-md text-weight-medium text-neutral">
            Additional Addresses
          </span>
          <PBtn
            dense
            flat
            fluid
            link
            class="flex q-ml-auto"
            @click="addAddress"
          >
            <AddIcon class="icon--sm q-mr-sm" />
            <span>Add Address</span>
          </PBtn>
        </div>
        <q-separator />
      </div>

      <div
        v-for="(address, index) in localAddressList"
        :key="address._id"
        class="row q-col-gutter-x-xl q-col-gutter-y-sm"
      >
        <div class="col-12">
          <div class="flex justify-between">
            <span class="text-md text-weight-medium text-neutral">
              {{ address.type_display }} Address
            </span>
            <PBtn
              dense
              flat
              fluid
              link
              class="flex q-ml-auto"
              @click="editAddress(index)"
            >
              <EditIcon class="icon--sm q-mr-sm" />
              <span>Edit</span>
            </PBtn>
          </div>
        </div>

        <AddressFields v-model="localAddressList[index]" :disabled="true" />
      </div>
    </div>
  </div>
</template>

<script setup>
import EditIcon from "assets/icons/edit.svg";
import AddIcon from "assets/icons/add.svg";
import AddressFields from "./AddressFields.vue";

// Store and props
const { toggleAddAddressForm } = useAddressStore();
const { primaryAddress, otherAddresses } = storeToRefs(useAddressStore());

const props = defineProps({
  initAddressList: {
    type: Function,
    required: false,
    default: () => {},
  },
});

// Reactive address list
const localAddressList = ref([...(unref(otherAddresses) || [])]);

// Add address handler
const addAddress = () => {
  toggleAddAddressForm({
    open: true,
    level: 0,
    props: {
      primaryAddress: unref(primaryAddress),
      updateParent: props.initAddressList,
    },
  });
};

// Edit address handler
const editAddress = (index) => {
  const selectedAddress = localAddressList.value[index];

  toggleAddAddressForm({
    open: true,
    edit: true,
    level: 0,
    props: {
      primaryAddress: unref(primaryAddress),
      editAddress: selectedAddress,
      updateParent: props.initAddressList,
    },
  });
};

// Watch otherAddresses and sync with localAddressList
watch(
  otherAddresses,
  (newAddresses) => {
    localAddressList.value = [...unref(newAddresses)];
  },
  { immediate: true },
);
</script>
